import { useState } from 'react';
import type { Movie } from '@filmsloth/shared';
import { useMovieTitle, useT } from '../i18n/index.js';
import { share } from '../lib/share.js';

/**
 * Shares the pick. Confirms what actually happened rather than claiming
 * success: the system sheet and the clipboard are different outcomes, and a
 * person who thinks they shared and did not is worse off than one who knows.
 */
export function ShareButton({ movie, className }: { movie: Movie; className?: string }) {
  const t = useT();
  const movieTitle = useMovieTitle();
  const [outcome, setOutcome] = useState<'copied' | 'failed' | null>(null);

  const label =
    outcome === 'copied'
      ? t('share.copied')
      : outcome === 'failed'
        ? t('share.failed')
        : t('share.action');

  return (
    <button
      type="button"
      className={className ?? 'btn'}
      onClick={() => {
        void share({
          title: t('share.subject'),
          text:
            movie.year !== null
              ? t('share.body', { title: movieTitle(movie), year: movie.year })
              : t('share.bodyNoYear', { title: movieTitle(movie) }),
        }).then((result) => {
          // A dismissed sheet gets no message: the person closed it on purpose.
          if (result === 'copied') setOutcome('copied');
          else if (result === 'failed') setOutcome('failed');
          else setOutcome(null);
        });
      }}
    >
      {label}
    </button>
  );
}
